export const AuthTokenKey = 'token';
export const MarvelUrl = 'https://marvelapp.com';
export const GraphqlEndpoint = 'https://api.marvelapp.com/graphql';
export const ClientId = 'VcCPOa1Joo645n3bVQRyvjORiVk9ncaYMXkbpjME';
export const Scopes =
  'projects:read user:read company.projects:read company:read company.projects:read';
